import { ReduxStore } from 'store/types';

function accessToken(state: ReduxStore): string | null {
  return state.auth.authorization.accessToken;
}

export default accessToken;
